import Image from 'next/image'
import { StoryblokServerComponent, storyblokEditable } from '@storyblok/react/rsc'
import Section from '@audioeye-marketing/ui/src/components/Section'
import Container from '@audioeye-marketing/ui/src/components/Container'
import Grid from '@audioeye-marketing/ui/src/components/Grid'
import Stack from '@audioeye-marketing/ui/src/components/Stack'
import translateSectionStyles from '@/lib/translate-section-styles'
import determineDividerColor from '@/lib/determine-divider-color'
import BackgroundTexture from '@/assets/components/background-texture.png'

const SplitContent = ({ blok, rels, headingLevel, padding, imagePriority, lowerHeadingStyles }) => {
  const sectionStyles = translateSectionStyles(blok?.section_styles?.[0])
  const texture = blok?.texture && <TexturedImage position={blok?.reverse_content ? 'left' : 'right'} />
  const textContentProps = {
    justifyCtaContent: { xs: 'flex-start', md: 'flex-start' },
    alignItems: { xs: 'flex-start', md: 'flex-start' },
    textAlign: { xs: 'left', md: 'left' },
    lowerHeadingStyles,
  }
  const dividerColor = determineDividerColor({ backgroundColor: sectionStyles?.backgroundColor })
  const divider = blok?.divider
    ? {
        position: 'relative',
        '::after': {
          content: '""',
          position: 'absolute',
          top: { xs: blok?.reverse_content ? 0 : '', md: 0 },
          right: { xs: 0, md: '' },
          left: { xs: 0, md: 'auto' },
          bottom: { xs: blok?.reverse_content ? '' : 0, md: 0 },
          width: { xs: '90%', md: '1px' },
          height: { xs: '1px', md: '70%' },
          marginTop: { xs: '', md: 'auto' },
          marginBottom: { xs: '', md: 'auto' },
          marginLeft: { xs: 'auto', md: '' },
          marginRight: { xs: 'auto', md: '' },
          backgroundColor: dividerColor,
        },
      }
    : {}

  return (
    <Section {...storyblokEditable(blok)} {...sectionStyles} id={blok?.anchor?.[0]?.anchor_id} padding={padding}>
      <Container constraint="lg">
        <Grid direction={blok?.reverse_content ? 'row-reverse' : 'row'} container spacing={{ xs: 5, md: 10 }}>
          <Grid xs={12} md={6} sx={!blok.reverse_content ? { ...divider } : {}}>
            <Stack
              justifyContent={blok?.media?.[0]?.component === 'Form' ? 'flex-start' : 'center'}
              sx={{ height: '100%' }}
            >
              {blok?.text_content?.map((currentTextContent) => (
                <StoryblokServerComponent
                  key={currentTextContent?._uid}
                  blok={currentTextContent}
                  rels={rels}
                  backgroundColor={sectionStyles?.backgroundColor}
                  headingLevel={headingLevel}
                  {...textContentProps}
                />
              ))}
            </Stack>
          </Grid>
          <Grid xs={12} md={6} sx={blok.reverse_content ? { ...divider } : {}}>
            <Stack
              sx={{ height: '100%' }}
              alignItems={{ xs: 'flex-start', sm: 'center' }}
              justifyContent={blok?.media?.[0]?.component === 'Button Group' ? 'flex-end' : 'center'}
            >
              {blok?.media?.map((currentMedia) => (
                <StoryblokServerComponent
                  key={currentMedia?._uid}
                  blok={currentMedia}
                  rels={rels}
                  card
                  animateImage
                  imagePriority={imagePriority}
                  backgroundColor={sectionStyles?.backgroundColor}
                  headingLevel={headingLevel}
                  {...(blok?.media?.[0]?.component === 'Text Content' ? textContentProps : {})}
                />
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Container>
      {texture}
    </Section>
  )
}

const TexturedImage = ({ position }) => {
  return (
    <Image
      src={BackgroundTexture}
      alt=""
      role="presentation"
      width="350"
      height="180"
      style={{
        position: 'absolute',
        top: 0,
        [position || 'right']: 0,
        mixBlendMode: 'color-dodge',
      }}
    />
  )
}

export default SplitContent
